const options = {
  5: "bg-amber-900/5",
  10: "bg-amber-900/10",
  25: "bg-amber-900/25",
  50: "bg-amber-900/50",
  75: "bg-amber-900/75",
  90: "bg-amber-900/90",
  100: "bg-amber-900",
};

const from = {
  5: "from-amber-900/5",
  10: "from-amber-900/10",
  25: "from-amber-900/25",
  50: "from-amber-900/50",
  75: "from-amber-900/75",
  90: "from-amber-900/90",
  100: "from-amber-900",
};

export default function getBackgroundAmber900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
